import React, { useEffect } from "react";
import useState from "react-usestateref";
import { useNavigate } from "react-router-dom";
import { ExclamationCircleIcon } from "@heroicons/react/outline";
import signupserviceInstance from "../services.js/signupservice";
import { ToastContainer, toast } from "react-toastify";
import toastProp from "../global/toastProps";
import { ArrowRightIcon, RefreshIcon } from "@heroicons/react/solid";
import { useForm } from "react-hook-form";
import OptionList from "./options";
import axios from "axios";
import validator from "validator";
import ReactCodeInput from "react-code-input";
import moment from "moment";
const maskEmail = (mail) => {
  var splitEmail = mail.split("@");
  var domain = splitEmail[1];
  var name = splitEmail[0];
  return name.substring(0, 3).concat("*********@").concat(domain);
};
function SignupScreen() {
  const navigate = useNavigate();
  const [firstName, setFirstName, firstNameRef] = useState("");
  const [lastName, setLastName, lastNameRef] = useState("");
  const [username, setUsername, usernameRef] = useState("");
  const [email, setEmail, emailRef] = useState("");
  const [password, setPassword, passwordRef] = useState("");
  const [confirmPassword, setConfirmPassword, confirmPasswordRef] =
    useState("");
  const [country, setCountry] = useState("");
  const [dob, setDob, dobRef] = useState("");
  const [otp, setOtp] = useState("");
  const [userData, setUserData] = useState({});
  const [emailError, setEmailError] = useState("");
  const [isEmailValid, setEmailIsValid, isEmailValidRef] = useState(true);
  const [isUsernameValid, setUsernameIsValid, isUsernameValidRef] =
    useState(true);
  const [isPasswordValid, setPasswordIsValid, isPasswordValidRef] =
    useState(true);
  const [
    isConfirmPasswordValid,
    setConfirmPasswordIsValid,
    isConfirmPasswordValidRef,
  ] = useState(true);
  const [isFirstNameValid, setFirstNameIsValid, isFirstNameValidRef] =
    useState(true);
  const [isLastNameValid, setLastNameIsValid, isLastNameValidRef] =
    useState(true);
  const [emailVerificationScreenState, setEmailVerficationScreenState] =
    useState(false);
  const [dobIsValid, setDobIsValid, dobIsValidRef] = useState(true);
  const [counter, setCounter] = useState(60);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const timer =
      counter > 0 && setInterval(() => setCounter(counter - 1), 1000);
    return () => clearInterval(timer);
  }, [counter]);
  function signup(e) {
    if (
      !(
        firstName.length === 0 ||
        lastName.length === 0 ||
        username.length === 0 ||
        email.length === 0 ||
        password.length === 0 ||
        confirmPassword.length === 0
      )
    ) {
      setLoading(true);
      e.preventDefault();
      const id = toast.loading("Sending OTP...", { theme: "light" });
      axios
        .post(process.env.REACT_APP_URL + "/signupData", {
          firstname: firstName,
          lastname: lastName,
          username: username,
          email: email,
          password: password,
          country: country,
          dateofbirth: dob,
        })
        .then((response) => {
          toast.update(id, toastProp("OTP sent to your email.", true));
          setUserData(response.data.user);

          setEmailVerficationScreenState(true);
          setCounter(60);
          setLoading(false);
        })
        .catch((error, response) => {
          toast.update(id, toastProp(error.response.data, false));
          setLoading(false);
        });
    } else {
      e.preventDefault();
      toast.error("Please fill all the fields", { theme: "light" });
    }
  }
  function compSignUp(e) {
    const id = toast.loading("Signing up...", { theme: "light" });
    setLoading(true);
    e.preventDefault();
    toast.update(id, {
      render: "Verifying OTP...",
      isLoading: true,
      theme: "light",
    });
    axios
      .post(process.env.REACT_APP_URL + "/signupverify", {
        otp: otp,
        user: userData,
      })
      .then((response) => {
        toast.update(id, toastProp("Verified, you've been registered.", true));
        setLoading(false);
        navigate("/login");
      })
      .catch((error, response) => {
        toast.update(id, toastProp(error.response.data, false));
        setLoading(false);
      });
  }

  const emailValidation = () => {
    if (validator.isEmail(emailRef.current)) {
      setEmailIsValid(true);
    } else {
      setEmailIsValid(false);
    }
  };
  const usernameValidation = () => {
    const usernameRegex = /^(?!.*\.\.)(?!.*\.$)[^\W][\w.]{0,29}$/i;
    if (usernameRegex.test(usernameRef.current)) {
      setUsernameIsValid(true);
    } else {
      setUsernameIsValid(false);
    }
  };
  const dobValidation = () => {
    if (dateComparsion()) {
      setDobIsValid(true);
    } else {
      setDobIsValid(false);
    }
  };
  const passwordValidation = () => {
    const passwordRegex =
      /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d@$!%*#?&()*^%~{}=+-_]{8,}$/i;
    if (passwordRegex.test(passwordRef.current)) {
      setPasswordIsValid(true);
    } else {
      setPasswordIsValid(false);
    }
  };
  const confirmPasswordValidation = () => {
    if (passwordRef.current === confirmPasswordRef.current) {
      setConfirmPasswordIsValid(true);
    } else {
      setConfirmPasswordIsValid(false);
    }
  };
  const firstNameValidation = () => {
    const name = /^(?=.{1,40}$)[a-zA-Z]+(?:[-'\s][a-zA-Z]+)*$/i;
    if (name.test(firstNameRef.current)) {
      setFirstNameIsValid(true);
    } else {
      setFirstNameIsValid(false);
    }
  };
  const lastNameValidation = () => {
    const name = /^(?=.{1,40}$)[a-zA-Z]+(?:[-'\s][a-zA-Z]+)*$/i;
    if (name.test(lastNameRef.current)) {
      setLastNameIsValid(true);
    } else {
      setLastNameIsValid(false);
    }
  };
  const formValidation = () => {
    if (
      isFirstNameValidRef.current &&
      isLastNameValidRef.current &&
      isUsernameValidRef.current &&
      isEmailValidRef.current &&
      isPasswordValidRef.current &&
      isConfirmPasswordValidRef.current &&
      dateComparsion()
    ) {
      return true;
    } else {
      return false;
    }
  };
  const dateComparsion = () => {
    const date = moment(new Date(dobRef.current), "YYYYMMDD").fromNow();
    if (date.includes("years")) {
      const yearsOld = parseInt(date.split(" ")[0]);
      if (yearsOld >= 13) {
        return true;
      } else {
        return false;
      }
    } else {
      console.log(date);
      return false;
    }
  };

  return (
    <>
      {emailVerificationScreenState ? (
        <div className="h-screen m-0  flex justify-center">
          <div className="p-[3%] m-5 bg-plaette_color2 shadow-md shadow-black rounded-lg items-center flex justify-center ">
            <div>
              <h2 className="text-black font-robo  text-center text-4xl  ">
                Email Verfication
              </h2>
              <h1 className="pt-4 text-md font-robo text-secondary text-center ">
                Enter the OTP sent to your email <br />
                {maskEmail(email)}
              </h1>

              <div className="col-span-6 sm:col-span-3 ">
                <div className="w-[100%]">
                  <label className="block font-robo text-md text-black mt-3 ">
                    OTP
                    <span className="text-[#ff0000]"> *</span>
                  </label>
                  {/* <input
                      type="text"
                      name="otp"
                      id="otp"
                      className="appearance-none rounded relative block w-full px-3 py-2 border border-gray-400 placeholder-gray-500 text-gray-900 rounded-t-md focus:outline-none focus:border-green-500 focus:z-10 sm:text-sm my-1"
                      placeholder="Enter OTP"
                      onChange={(e) => setOtp(e.target.value)}
                      required
                    /> */}
                  <div className="flex w-[100%] justify-center align-middle">
                    <ReactCodeInput
                      type="text"
                      fields={6}
                      required
                      value={otp}
                      onChange={(e) => setOtp(e)}
                    />
                  </div>
                  {/* If OTP is incorrect implement logic on h3 to show/hide error message */}
                  <h3 className="text-xl text-center font-robo text-secondary mt-5 ">
                    Resend OTP in 00:
                    <span
                      className={`${
                        counter < 10 ? "text-[#ff0000]" : "text-green-600"
                      }`}
                    >
                      {counter < 10 ? "0" + counter : counter}
                    </span>
                  </h3>
                  <div className="flex justify-between items-center">
                    <div className="py-10 text-left ">
                      {counter === 0 && (
                        <button
                          type="submit"
                          className="flex justify-center text-xl font-robo text-palette_color1 hover:underline focus:outline-none"
                          onClick={signup}
                          disabled={loading ? true : false}
                        >
                          <span>
                            <RefreshIcon
                              className="h-5 w-5 my-1 mx-2  "
                              aria-hidden="true"
                            />
                          </span>
                          Resend
                        </button>
                      )}
                    </div>
                    <div className="py-10 text-right">
                      <button
                        type="submit"
                        className="font-robo   antialiased  group relative  flex justify-center py-2 px-4 border-none text-xl rounded-md text-white bg-palette_color1 hover:opacity-80  focus:outline-none shadow-sm"
                        onClick={compSignUp}
                        disabled={loading ? true : false}
                      >
                        Verify
                        <span>
                          <ArrowRightIcon
                            className="h-5 w-5 my-1 ml-2 "
                            aria-hidden="true"
                          />
                        </span>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      ) : (
        <div className="h-screen ">
          <div className="flex justify-center h-full items-center">
            <div className="flex flex-col bg-palette_color2 shadow-md shadow-black rounded-lg items-center p-[1.5%] m-3">
              <h2 className="font-robo text-black text-center text-3xl antialiased">
                Register Yourself
              </h2>
              <form action="#">
                <div className="px-4 py-5 sm:p-6">
                  <div className="grid grid-cols-6 gap-6">
                    <div className="col-span-6 sm:col-span-3 h-22">
                      <label className="block text-lg font-robo  text-black antialiased">
                        First name
                        <span className="text-[#FF0000]"> *</span>
                      </label>
                      <div className="flex items-center relative">
                        <input
                          type="text"
                          name="first-name"
                          id="first-name"
                          autoComplete="given-name"
                          className={`${
                            isFirstNameValidRef.current
                              ? "focus:border-green-500 "
                              : "border-[#FF0000] "
                          }"appearance-none rounded relative block w-full px-3 py-2 border-[1px] border-palette_color1  placeholder-secondary text-black rounded-t-md focus:outline-none focus:z-10 sm:text-sm"`}
                          placeholder="First Name"
                          onChange={(e) => {
                            setFirstName(e.target.value);
                            firstNameValidation();
                          }}
                        />
                        {!isFirstNameValidRef.current ? (
                          <ExclamationCircleIcon
                            className="h-5 w-5 text-[#ff0000] mx-1 absolute right-0"
                            aria-hidden="true"
                          />
                        ) : null}
                      </div>

                      {!isFirstNameValidRef.current ? (
                        <h3 className="text-sm italic text-[#ff0000] font-proxima tracking-wide">
                          * First name must contain only letters
                        </h3>
                      ) : null}
                    </div>

                    <div className="col-span-6 sm:col-span-3 h-22">
                      <label className="block text-lg font-robo  text-black antialiased">
                        Last name
                        <span className="text-[#ff0000]"> *</span>
                      </label>
                      <div className="flex items-center relative">
                        <input
                          type="text"
                          name="last-name"
                          id="last-name"
                          autoComplete="family-name"
                          className={`${
                            isLastNameValidRef.current
                              ? "focus:border-green-500 "
                              : "border-[#FF0000] "
                          }"appearance-none rounded relative block w-full px-3 py-2 border-[1px] border-palette_color1  placeholder-secondary text-black rounded-t-md focus:outline-none focus:z-10 sm:text-sm"`}
                          placeholder="Last name"
                          onChange={(e) => {
                            setLastName(e.target.value);
                            lastNameValidation();
                          }}
                        />
                        {!isLastNameValidRef.current ? (
                          <ExclamationCircleIcon
                            className="h-5 w-5 text-[#ff0000] mx-1 absolute right-0"
                            aria-hidden="true"
                          />
                        ) : null}
                      </div>
                      {!isLastNameValidRef.current ? (
                        <h3 className="text-sm italic text-[#ff0000] font-proxima tracking-wide">
                          * Last name must contains only letters
                        </h3>
                      ) : null}
                    </div>

                    <div className="col-span-6 sm:col-span-3 h-22">
                      <label className="block text-lg font-robo  text-black antialiased">
                        Email
                        <span className="text-[#ff0000]"> *</span>
                      </label>
                      <div className="flex items-center relative">
                        <input
                          type="email"
                          name="email"
                          id="email-address"
                          autoComplete="email"
                          className={`${
                            isEmailValidRef.current
                              ? "focus:border-green-500 "
                              : "border-[#FF0000] "
                          }"appearance-none rounded relative block w-full px-3 py-2 border-[1px] border-palette_color1  placeholder-secondary text-black rounded-t-md focus:outline-none focus:z-10 sm:text-sm"`}
                          placeholder="Email Address"
                          onChange={(e) => {
                            setEmail(e.target.value);
                            emailValidation();
                          }}
                        />
                        {!isEmailValidRef.current ? (
                          <ExclamationCircleIcon
                            className="h-5 w-5 text-[#ff0000] mx-1 absolute right-0"
                            aria-hidden="true"
                          />
                        ) : null}
                      </div>
                      {!isEmailValidRef.current ? (
                        <h3 className="text-sm italic text-[#ff0000] font-proxima tracking-wide">
                          * Enter a valid email
                        </h3>
                      ) : null}
                    </div>
                    <div className="col-span-6 sm:col-span-3 h-22">
                      <label className="block text-lg font-robo  text-black antialiased">
                        Username
                        <span className="text-[#ff0000]"> *</span>
                      </label>
                      <div className="flex items-center relative">
                        <input
                          type="text"
                          name="username"
                          id="username"
                          autoComplete="family-name"
                          className={`${
                            isUsernameValidRef.current
                              ? "focus:border-green-500 "
                              : "border-[#FF0000] "
                          }"appearance-none rounded relative block w-full px-3 py-2 border-[1px] border-palette_color1  placeholder-secondary text-black rounded-t-md focus:outline-none focus:z-10 sm:text-sm"`}
                          placeholder="Username"
                          onChange={(e) => {
                            setUsername(e.target.value);
                            usernameValidation();
                          }}
                        />
                        {!isUsernameValidRef.current ? (
                          <ExclamationCircleIcon
                            className="h-5 w-5 text-[#ff0000] mx-1 absolute right-0"
                            aria-hidden="true"
                          />
                        ) : null}
                      </div>
                      {!isUsernameValidRef.current ? (
                        <h3 className="text-sm italic text-[#ff0000] font-proxima tracking-wide">
                          * Enter a valid username
                        </h3>
                      ) : null}
                    </div>

                    <div className="col-span-6 sm:col-span-3 h-22">
                      <label className="block text-lg font-robo  text-black antialiased">
                        Country
                      </label>
                      <select
                        id="country"
                        name="country"
                        autoComplete="country-name"
                        className="rounded relative block w-full px-3 py-2 border-[1px] border-palette_color1 bg-white placeholder-secondary text-black rounded-t-md focus:outline-none focus:z-10 sm:text-sm"
                        onChange={(e) => setCountry(e.target.value)}
                      >
                        <OptionList />
                      </select>
                      {/* {country.length === 0 ? (
              <h3 className="text-sm italic text-red-600 font-bold">
                * Country is required
              </h3>) : null} */}
                    </div>

                    <div className="col-span-6 sm:col-span-3 h-22">
                      <label className="block text-lg font-robo  text-black antialiased">
                        Date of Birth
                        <span className="text-[#ff0000]"> *</span>
                      </label>
                      <input
                        datepicker
                        datepicker-format="dd/mm/yyyy"
                        type="date"
                        className="appearance-none rounded w-full px-3 py-2 border-[1px] border-palette_color1 bg-white placeholder-secondary text-black rounded-t-md focus:outline-none focus:z-10 sm:text-sm"
                        placeholder="Date of Birth"
                        onChange={(e) => {
                          setDob(e.target.value);
                          dobValidation();
                        }}
                      />
                      {!dobIsValid? (
                        <h3 className="text-sm italic text-[#ff0000] font-proxima tracking-wide">
                          * Date of birth must be 13 years or greater
                        </h3>
                      ) : null}
                    </div>

                    <div className="col-span-6 sm:col-span-3 h-22">
                      <label className="block text-lg font-robo  text-black antialiased">
                        Password
                        <span className="text-[#ff0000]"> *</span>
                      </label>
                      <div className="flex items-center relative">
                        <input
                          type="password"
                          name="password"
                          id="password"
                          autoComplete="current-password"
                          className={`${
                            isPasswordValidRef.current
                              ? "focus:border-green-500 "
                              : "border-[#FF0000] "
                          }"appearance-none rounded relative block w-full px-3 py-2 border-[1px] border-palette_color1  placeholder-secondary text-black rounded-t-md focus:outline-none focus:z-10 sm:text-sm"`}
                          placeholder="Password"
                          onChange={(e) => {
                            setPassword(e.target.value);
                            passwordValidation();
                          }}
                          minLength="8"
                        />
                        {!isPasswordValidRef.current ? (
                          <ExclamationCircleIcon
                            className="h-5 w-5 text-[#ff0000] mx-1 absolute right-0"
                            aria-hidden="true"
                          />
                        ) : null}
                      </div>
                      {!isPasswordValidRef.current ? (
                        <h3 className="italic text-[#ff0000] text-xs font-proxima tracking-wide">
                          * Password must have atleast 8 <br /> characters,
                          atleast 1 number and 1 letter
                        </h3>
                      ) : null}
                    </div>
                    <div className="col-span-6 sm:col-span-3 h-22">
                      <label className="block text-lg font-robo  text-black antialiased">
                        Confirm Password
                        <span className="text-[#ff0000]"> *</span>
                      </label>
                      <div className="flex items-center relative">
                        <input
                          type="password"
                          name="confirm-password"
                          id="confirm-password"
                          className={`${
                            isConfirmPasswordValidRef.current
                              ? "focus:border-green-500 "
                              : "border-[#FF0000] "
                          }"appearance-none rounded relative block w-full px-3 py-2 border-[1px] border-palette_color1  placeholder-secondary text-black rounded-t-md focus:outline-none focus:z-10 sm:text-sm"`}
                          placeholder="Confirm Password"
                          onChange={(e) => {
                            setConfirmPassword(e.target.value);
                            confirmPasswordValidation();
                          }}
                        />
                        {!isConfirmPasswordValidRef.current ? (
                          <ExclamationCircleIcon
                            className="h-5 w-5 text-[#ff0000] mx-1 absolute right-0"
                            aria-hidden="true"
                          />
                        ) : null}
                      </div>
                      {!isConfirmPasswordValidRef.current ? (
                        <h3 className="text-sm italic text-[#ff0000] font-proxima tracking-wide">
                          * Password is not same
                        </h3>
                      ) : null}
                    </div>
                  </div>
                </div>
                <div className="flex justify-end md:justify-between items-center px-4 sm:px-6">
                  <div className=" hidden md:flex justify-center">
                    
                      <h1 className="block text-lg font-robo  text-black antialiased">
                        Already have an account?{" "}
                        <span
                          className="text-palette_color1 font-robo antialiased text-xl hover:underline hover:cursor-pointer "
                          onClick={(e) => {
                            e.preventDefault();
                            navigate("/login");
                          }}
                        >
                          Log in
                        </span>
                      </h1>
                    
                  </div>
                  <button
                    type="submit"
                    className="font-robo  font-semibold antialiased  group relative  flex justify-center py-2 px-4 border-none text-xl rounded-md text-white bg-palette_color1 hover:opacity-80  focus:outline-none shadow-sm"
                    onClick={(e) => {
                      if (formValidation()) {
                        signup(e);
                      } else {
                        e.preventDefault();
                        toast.error("Please fill all the fields correctly", {
                          theme: "light",
                        });
                      }
                    }}
                    disabled={loading ? true : false}
                  >
                    Register
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default SignupScreen;
